import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const findWorkOrderList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-work/v1/appointment-card/list?` + params,
    method: "GET",
  });
};
export const addCard = (params) => {
  return request({
    url: `${baseUrl}/joins-work/v1/appointment-card/downloadDoc`,
    method: "POST",
    responseType: 'blob',
    data: params,
  });
};
export const findWorkShopItem = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/selectShops`,
    method: "GET",
  });
};